import React, { createContext, useContext, useState } from 'react';

const AccountContext = createContext();

export const useAccount = () => {
  const context = useContext(AccountContext);
  if (!context) {
    throw new Error('useLoading must be used within a AccountProvider');
  }
  return context;
};

export const AccountProvider = ({ children }) => {

  const getLocalStorage = (name) => {
    const storedValue = localStorage.getItem(name);
    return storedValue ? JSON.parse(storedValue) : null;
  };

  const [Username, setUsername] = useState(getLocalStorage('UserName'));
  const [UserEmail, setUserEmail] = useState(getLocalStorage('UserEmail'));
  const GetUsername = () => {
    if (Username) {
      return (Username)
    } else {
      return ('Login/SignUp')
    }
  }

  const GetEmail = () => {
    if (UserEmail) {
      return (UserEmail)
    } else {
      return ('NoEmail')
    }
  }

  const AccountObj=()=>{
    if(Username&&UserEmail){
      return({
        Username: Username,
        UserEmail: UserEmail
      })
    }else{
      return({
        Username: 'NOTLOGIN',
        UserEmail: 'NOTLOGIN'
      })
    }
  }

  const Account=()=>{
    if(Username&&UserEmail){
      return(true)
    }else{
      return(false)
    }
  }

  return (
    <AccountContext.Provider value={{ GetUsername , GetEmail , AccountObj , Account }}>
      {children}
    </AccountContext.Provider>
  );
};